var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46975 6.77448C6.42037 6.82832 6.36034 6.87131 6.29347 6.90072C6.22659 6.93013 6.15434 6.94531 6.08128 6.94531C6.00823 6.94531 5.93597 6.93013 5.8691 6.90072C5.80223 6.87131 5.7422 6.82832 5.69282 6.77448L1.09347 1.75662C1.02364 1.68133 0.977326 1.58728 0.960215 1.48603C0.943102 1.38479 0.955936 1.28074 0.997141 1.18669C1.03835 1.09264 1.10613 1.01266 1.19216 0.956602C1.27818 0.900539 1.37872 0.870826 1.4814 0.871113L10.6801 0.871113C10.7825 0.871 10.8827 0.900697 10.9684 0.956577C11.0542 1.01246 11.1218 1.0921 11.1631 1.18579C11.2043 1.27947 11.2174 1.38314 11.2007 1.48413C11.184 1.58513 11.1383 1.67908 11.0691 1.75451L6.46975 6.77448Z",
    fill: "url(#paint0_linear_57_188)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_188",
    x1: 11.2078,
    y1: 3.90821,
    x2: 0.952844,
    y2: 3.90821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52AE32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006535"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.ae87d348bfb629dc1aa44e16c707f2f1.svg";
export { ForwardRef as ReactComponent };